import en from "./en";
import zh from "./zh";
import it from "./it";
import type { Locale } from "../config";

export type { Messages } from "./en";
export const messages = { en, zh, it } satisfies Record<Locale, typeof en>;
